import React,{createContext,useContext,useState,useEffect} from 'react';
import API from '../api/axios';
const Ctx=createContext(null);
export const AuthProvider=({children})=>{
  const [user,setUser]=useState(()=>{try{return JSON.parse(localStorage.getItem('hm_user'));}catch{return null;}});
  const [loading,setLoading]=useState(true);
  useEffect(()=>{
    const t=localStorage.getItem('hm_token');
    if(t){API.get('/auth/me').then(r=>{setUser(r.data.user);localStorage.setItem('hm_user',JSON.stringify(r.data.user));}).catch(()=>{localStorage.clear();setUser(null);}).finally(()=>setLoading(false));}
    else setLoading(false);
  },[]);
  const login=async(email,password)=>{const r=await API.post('/auth/login',{email,password});localStorage.setItem('hm_token',r.data.token);localStorage.setItem('hm_user',JSON.stringify(r.data.user));setUser(r.data.user);return r.data.user;};
  const register=async(data)=>{const r=await API.post('/auth/register',data);localStorage.setItem('hm_token',r.data.token);localStorage.setItem('hm_user',JSON.stringify(r.data.user));setUser(r.data.user);return r.data.user;};
  const logout=()=>{localStorage.clear();setUser(null);};
  const updateUser=(u)=>{setUser(u);localStorage.setItem('hm_user',JSON.stringify(u));};
  return <Ctx.Provider value={{user,setUser:updateUser,login,register,logout,loading}}>{children}</Ctx.Provider>;
};
export const useAuth=()=>useContext(Ctx);
